import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'

import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { observable } from 'mobx'
import { observer,  } from 'mobx-react'
@observer  
class Menu extends Component {

	static propTypes = {
		match: PropTypes.object.isRequired,
		location: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired
	  }

	@observable mobileMenuVisible = false

	render() {
		return (
			<nav >
				<a href="tel:0419906922" className="mobile-phone"><i className="fa fa-phone"></i></a>
				<div className="mobile-menu" onClick={()=>this.mobileMenuVisible = !this.mobileMenuVisible}><i className="fa fa-bars"></i></div>
					<ul className={`mobile-menu-visible-${this.mobileMenuVisible}`}>
						
						<li>
							<NavLink to="/about" >About</NavLink>
						</li>
						
						<li>
							<NavLink to="/features" >Features</NavLink>
						</li>
						<li>
							<NavLink to="/pricing" >Pricing</NavLink>
						</li>
						{/* <li>
							<a href="https://online.gpbook.com.au/update">
								Listings
							</a>
						</li> */}
						<li>
							<NavLink to="/help" >Help</NavLink>
						</li>
						{/* 
						<li>
							<a href="http://psych.gpbook.com.au/" >
								Psychology
							</a> 
						</li> */}
						<li>
							<NavLink to="/contact" >Contact</NavLink>
						</li>
					
						<hr/>

						<li>
							<NavLink to="/purchase" className="btn secondary border-only" >
							Purchase
							</NavLink>
							
							{/* <div className="new">New</div> */}
						</li>
						<li className="login-dropdown">
							<a href="https://online.gpbook.com.au/" className="btn border-only">
								Login <i className="fa fa-chevron-down"></i>
							</a>
							<div className="dropdown-menu">
								<a href="https://online.gpbook.com.au/">Access the Directory</a>
								<a href="https://online.gpbook.com.au/update">Edit My Listing</a>
							</div>
						</li>
						
					</ul>
				</nav>	
		);
	}
}


export default withRouter(Menu);


// WEBPACK FOOTER //
// ./src/Components/Layout/Menu.js